module.exports = __webpack_public_path__ + "static/media/mobilebackground.cfb555b7.png";